export default __webpack_public_path__ + "static/media/exportDataSVG.3fd24cf3.svg";